import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { DropdownQuestion } from '../../question-dropdown';
import { TextboxQuestion } from '../../question-textbox';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';

@Injectable({
  providedIn: 'root',
})
export class EcontentServicesService {
  shiftdropdata: any = [];
  Coursesdata: any = [];
  semister_drop: any = [];
  subjects_drop: any = [];
  catogory_drop: any = [];

  selectedCourseValue: number = 0;
  selectedAccademichValue: any;
  selectedSemesterValue: number = 0;

  constructor(private dropdownservice: DropdownservicesService) {
    this.loadDropdownData('COURSES', this.Coursesdata);
    this.loadDropdownData('CONTENT_CATEGORIES', this.catogory_drop);
  }

  private loadDropdownData(code: string, dataArray: any[] = []) {
    let observable: Observable<any>;

    if (code === 'ORGANISATION') {
      observable = this.dropdownservice.getorganizationdrop();
    } else if (code === 'COURSES') {
      observable = this.dropdownservice.getcoursesbybatch(
        this.selectedAccademichValue
      );
    } else if (code === 'SEMISTER') {
      observable = this.dropdownservice.getcoursewisesemester({
        course_ID: this.selectedCourseValue,
      });
    } else if (code === 'SUBJECTS') {
      observable = this.dropdownservice.getecontentsubjectsdrop({
        course_ID: this.selectedCourseValue,
        semester_ID: this.selectedSemesterValue,
      });
    } else {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }
    observable.subscribe((res) => {
      const tempData: any[] = [];

      for (let i = 0; i < res?.length; i++) {
        let lookupname;
        if (code === 'SEMISTER') {
          lookupname = res[i]?.name;
        } else if (code === 'COURSES') {
          if (res[i]?.medium_name !== 'ENGLISH') {
            lookupname = res[i]?.name + '(' + res[i]?.medium_name + ')';
          } else {
            lookupname = res[i]?.name;
          }
        } else if (code === 'SUBJECTS') {
          lookupname = res[i]?.subject_name;
        } else {
          lookupname = res[i].lookup_name;
        }

        if (lookupname != null) {
          tempData.push({
            id: code === 'SUBJECTS' ? res[i].subject_id : res[i].id,
            key: lookupname,
            value: code === 'SUBJECTS' ? res[i].subject_id : res[i].id,
          });
        }
      }

      // Replace the old array completely (prevent duplicates)
      dataArray.length = 0;
      dataArray.push(...tempData);
    });
  }
  onCourseChange(selectedValue: any): void {
    this.selectedCourseValue = selectedValue;
    this.semister_drop.splice(0, this.semister_drop.length);
    this.subjects_drop.splice(0, this.subjects_drop.length);
    this.loadDropdownData('SEMISTER', this.semister_drop);
  }

  onSemesterChange(selectedValue: any): void {
    this.selectedSemesterValue = selectedValue;
    this.subjects_drop.splice(0, this.subjects_drop.length);
    this.loadDropdownData('SUBJECTS', this.subjects_drop);
  }

  getecontentform() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'econtent_title',
        label: 'Econtent Title',
        required: true,
        order: 1,
      }),

      new DropdownQuestion({
        key: 'courses_id',
        label: 'Courses',
        options: this.Coursesdata,
        required: true,
        order: 2,
        onChange: this.onCourseChange.bind(this),
      }),
      new DropdownQuestion({
        key: 'semister_id',
        label: 'Semister',
        options: this.semister_drop,
        required: true,
        order: 3,
        onChange: this.onSemesterChange.bind(this),
      }),
      new DropdownQuestion({
        key: 'category_id',
        label: 'Category',
        options: this.catogory_drop,
        required: true,
        order: 4,
      }),
      new DropdownQuestion({
        key: 'subject_id',
        label: 'Subject',
        options: this.subjects_drop,
        required: true,
        order: 5,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
  showecontentdocform() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'econtent_title',
        label: 'Econtent Title',
        required: true,
        order: 1,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
